import React, { useState } from "react";
import { Link } from "react-router-dom";
import BookDemoModal from "../components/Resuseables/BookDemoModal/BookDemoModal";

function ContactUs() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
    <section className="text-center px-6 md:px-20 py-10 mt-20">
      <header className="mb-8 space-y-4">
        <h2 className="text-xl md:text-5xl font-semibold">
          <span className="text-primary">Ready to Transform Your</span>
          <br className="md:my-3" />
          <span className="text-secondary">Business Communication?</span>
        </h2>
        <p className=" text-sm text-base">
          Join thousands of businesses transforming their communication
          strategies with SleengShort. Sign up now and experience the power of
          instant messaging.
        </p>
      </header>

      <div className="flex gap-10 justify-center">
       
        <button
          onClick={() => setIsModalOpen(true)}
          className="border-2 border-primary text-primary py-2 md:px-6 px-3 md:text-lg rounded-lg"
        >
          Book a Demo
        </button>
      </div>
    </section>

    <BookDemoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default ContactUs;
